import React from "react";
import V20Embed from "@/components/mock/V20Embed";
export default function Attachments() {
  return <V20Embed view="attachments" testid="attachments-view" />;
}
